// src/utils/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ element, allowedRoles = [] }) {
  const location = useLocation();

  const token = localStorage.getItem("token");
  let currentUser = null;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      currentUser = { nivel: decoded.position };
    } catch (err) {
      console.error("❌ Token inválido:", err);
    }
  }

  if (!currentUser || !allowedRoles.includes(currentUser.nivel)) {
    return <Navigate to="/acesso-negado/" replace state={{ from: location }} />;
  }

  return element;
}
